import { t } from '@/utils/i18n'
import React from 'react'
import { utils } from '@/utils'
import styles from './SearchBar.module.less'
import Icon from '@/components/Icon/Icon'

// 导入图片
// import iconSplit from '@/assets/img/icon/split.svg'
// import iconSearch from '@/assets/img/icon/search.png'
// import iconScan from '@/assets/img/icon/scan.png'
import IconClose from '@/assets/img/icon/close.svg'

const { debounce } = utils

interface SearchBarProps {
  customizeStyle?: any
  placeholder?: string
  enableSearch?: boolean
  text?: string
  onSearch?: any
  onScanSearch?: any // 扫码搜索
  className?: string
  isShowScan?: boolean
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = t('搜索'),
  enableSearch = false,
  text = '',
  onSearch = null,
  onScanSearch = null,
  className,
  customizeStyle,
  isShowScan = true,
}) => {
  const [searchText, setSearchText] = React.useState(text)
  const toSearch = (e: any) => {
    e.stopPropagation()
    if (onSearch) {
      onSearch(searchText)
    }
  }
  const style = {
    backgroundColor: '#f0f0f0',
    ...customizeStyle,
  }
  const handleScanProductCode = () => {
    onScanSearch()
  }

  const handleInput = debounce((e: any) => {
    const { value } = e.target
    onSearch(value)
  }, 300)

  const handleResetSearch = (e: any) => {
    e.stopPropagation()
    setSearchText('')
    onSearch('')
  }

  return (
    <div className={`${styles['search-bar']} ${className}`}>
      <div className={styles['bd']} style={style}>
        <div className={styles['title-search']} onClick={toSearch}>
          <Icon name="search" color="#7f7f7f" size="40" />

          <input
            className={styles['title-search-input']}
            type="text"
            placeholder={placeholder}
            value={searchText}
            onInput={handleInput}
            onChange={(e: any) => {
              setSearchText(e.target.value)
            }}
            readOnly={!enableSearch}
          />

          {enableSearch && searchText ? (
            <img
              className={styles['title-search-close']}
              src={IconClose}
              onClick={handleResetSearch}
            />
          ) : (
            ''
          )}
        </div>
        {isShowScan && (
          <Icon
            name="scan"
            color="#FE5700"
            className={styles['title-search-scan-icon']}
            size="48"
            onClick={handleScanProductCode}
          />
        )}
      </div>
    </div>
  )
}

export default SearchBar
